var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.5C15.5 9.433 13.933 11 12 11C10.067 11 8.5 9.433 8.5 7.5C8.5 5.567 10.067 4 12 4C13.933 4 15.5 5.567 15.5 7.5Z",
    fill: "#1576BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.5C18 18.433 15.3137 20 12 20C8.68629 20 6 18.433 6 16.5C6 14.567 8.68629 13 12 13C15.3137 13 18 14.567 18 16.5Z",
    fill: "#1576BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12205 5C7.29951 5 7.47276 5.01741 7.64005 5.05056C7.23249 5.77446 7 6.61008 7 7.5C7 8.36825 7.22131 9.18482 7.61059 9.89636C7.45245 9.92583 7.28912 9.94126 7.12205 9.94126C5.70763 9.94126 4.56102 8.83512 4.56102 7.47063C4.56102 6.10614 5.70763 5 7.12205 5Z",
    fill: "#1576BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44734 18.986C4.87942 18.3071 4.5 17.474 4.5 16.5C4.5 15.5558 4.85657 14.744 5.39578 14.0767C3.4911 14.2245 2 15.2662 2 16.5294C2 17.8044 3.5173 18.8538 5.44734 18.986Z",
    fill: "#1576BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9994 7.5C16.9994 8.36825 16.7781 9.18482 16.3888 9.89636C16.547 9.92583 16.7103 9.94126 16.8774 9.94126C18.2918 9.94126 19.4384 8.83512 19.4384 7.47063C19.4384 6.10614 18.2918 5 16.8774 5C16.6999 5 16.5267 5.01741 16.3594 5.05056C16.7669 5.77446 16.9994 6.61008 16.9994 7.5Z",
    fill: "#1576BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5521 18.986C20.4821 18.8538 21.9994 17.8044 21.9994 16.5294C21.9994 15.2662 20.5083 14.2245 18.6036 14.0767C19.1429 14.744 19.4994 15.5558 19.4994 16.5C19.4994 17.474 19.12 18.3071 18.5521 18.986Z",
    fill: "#1576BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9d99069c8ad53d54c07e5861e2909966.svg";
export { ForwardRef as ReactComponent };